export const STORAGE_KEYS = {
  USERINFO: 'loginInfo', 
  LOGIN_ID: 'yujin_ceCd',
  LOGIN_PW: 'yujin_cePw',
}

export const CE_TYPE =  {
  YUJIN: process.env.REACT_APP_TYPE_YUJIN,
  MASTER: process.env.REACT_APP_TYPE_MASTER,
  BRANCH: process.env.REACT_APP_TYPE_BRANCH,
  CENTER: process.env.REACT_APP_TYPE_CENTER,
};

export const COMPANY_TYPE =  {
  KNP: process.env.REACT_APP_TYPE_COMPANY_KNP,
  BENZ: process.env.REACT_APP_TYPE_COMPANY_BENZ
};

export const SUBNAME_TYPE = ['본사','서비스','전시장','중고차'];

